import { render, staticRenderFns } from "./Curtain.vue?vue&type=template&id=2ed61e4b&scoped=true&"
import script from "./Curtain.vue?vue&type=script&lang=js&"
export * from "./Curtain.vue?vue&type=script&lang=js&"
import style0 from "./Curtain.vue?vue&type=style&index=0&id=2ed61e4b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed61e4b",
  null
  
)

export default component.exports